/**
 * @Description 商圈详情-基本信息栏-热力图开关
 */

import { FC } from 'react';
import { Switch } from 'antd';
import styles from './index.module.less';
// import cs from 'classnames';

const HeatSwitch: FC<any> = ({
  checked,
  onChange,
}) => {
  return (
    <div className={styles.heatSwitch}>
      <span className='fs-12 c-666 mr-2'>热力图</span>
      <Switch
        checked={checked}
        className={styles.cutomizeSwitch}
        onChange={(val) => onChange?.(val)}
        style={{ width: 22, height: 12 }}
      />
    </div>
  );
};

export default HeatSwitch;
